// Campus photo for /colleges/stanford-university: CC BY-SA 4.0, by Jawed, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AStanford_University_Arches_with_Memorial_Church_in_the_background.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/stanford-university/; credited under the photo.
const photo = {
    "slug": "stanford-university",
    "alt": "Memorial Church seen through the sandstone arches of the Main Quad at Stanford University in Stanford, California",
    "src": "/colleges/stanford-university/campus-1600.webp",
    "srcSmall": "/colleges/stanford-university/campus-800.webp",
    "srcMid": "/colleges/stanford-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/stanford-university/og.jpg",
    "title": "Stanford University Arches with Memorial Church in the background",
    "author": "Jawed",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AStanford_University_Arches_with_Memorial_Church_in_the_background.jpg",
    "read": "2026-10-01"
};

export default photo;
